import validatorjs from 'validatorjs';
import { FormBase } from 'core/components';

export default class ProductPartForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		let validator = validatorjs;

		validator.register(
			'numericMinValue',
			value => {
				return 1 / value > 0;
			},
			'NUMERICMINVALUE'
		);
		validator.register(
			'notZero',
			value => {
				return value != 0;
			},
			'NOTZEROVALUE'
		);
		validator.register(
			'notDecimal',
			value => {
				return !value.toString().includes('.');
			},
			'NOTDECIMALVALUE'
		);

		return {
			fields: [
				{
					name: 'product',
					label: 'PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.PRODUCT',
					rules: 'required',
				},
				{
					name: 'quantity',
					label: 'PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.QUANTITY',
					rules: 'required|numeric|numericMinValue|notZero|notDecimal',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductPartForm.js